export default [
  {
    path: 'login',
    name: 'apps-auth-login',
    component: () => import(/* webpackChunkName: "apps-auth-login" */ '@/apps/auth/pages/LoginPage.vue'),
    meta: {
      layout: 'horizontal',
    },
  },
  {
    path: 'reconnect',
    name: 'apps-auth-reconnect',
    component: () => import(/* webpackChunkName: "apps-auth-reconnect" */ '@/apps/auth/pages/ReconnectPage.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: 'recovery',
    name: 'apps-auth-recovery',
    component: () => import(/* webpackChunkName: "apps-auth-recovery" */ '@/apps/auth/pages/RecoveryPage.vue'),
    meta: {
      layout: 'horizontal',
    },
  },
  {
    path: 'reset',
    name: 'apps-auth-reset',
    component: () => import(/* webpackChunkName: "apps-auth-reset" */ '@/apps/auth/pages/ResetPage.vue'),
    meta: {
      layout: 'horizontal',
    },
  },
  {
    path: 'logout',
    name: 'apps-auth-logout',
    component: () => import(/* webpackChunkName: "apps-auth-logout" */ '@/apps/auth/pages/LogoutPage.vue'),
    meta: {
      layout: 'blank',
    },
  },
]
